import {
  Add,
  Article,
  BarChart,
  CalendarMonth,
  Checklist,
  Clear,
  ContentCopy,
  Dashboard,
  DeleteForever,
  Edit,
  EditOutlined,
  ExpandLess,
  ExpandMore,
  FilterAlt,
  FilterAltOutlined,
  FirstPage,
  Folder,
  FolderOpen,
  Home,
  Inbox,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LastPage,
  Logout,
  Mail,
  MoreVert,
  PresentToAll,
  Save,
  Settings,
  SsidChart,
  StarBorder,
  SwapVert,
  ViewList,
} from "@mui/icons-material";
import { ReactElement } from "react";
// import { Folder, FolderOpen } from "./icons/Folder";

interface iconListInterface {
  [key: string]: ReactElement;
}

const iconList: iconListInterface = {
  // UI
  ExpandLess: <ExpandLess />,
  ExpandMore: <ExpandMore />,
  Logout: <Logout />,
  Add: <Add />,
  Edit: <Edit />,
  EditOutlined: <EditOutlined />,
  Save: <Save />,
  PresentToAll: <PresentToAll />,
  ContentCopy: <ContentCopy />,
  SwapVert: <SwapVert />,
  // Mail
  Inbox: <Inbox />,
  Mail: <Mail />,
  // Menu
  Article: <Article />,
  Folder: <Folder />,
  FolderOpen: <FolderOpen />,
  // Dashboard
  Dashboard: <Dashboard />,
  Settings: <Settings />,
  MoreVert: <MoreVert />,
  Clear: <Clear />,
  ViewList: <ViewList />,
  DeleteForever: <DeleteForever />,
  FilterAlt: <FilterAlt />,
  FilterAltOutlined: <FilterAltOutlined />,
  Checklist: <Checklist />,
  CalendarMonth: <CalendarMonth />,
  // Pager
  FirstPage: <FirstPage />,
  LastPage: <LastPage />,
  KeyboardArrowLeft: <KeyboardArrowLeft />,
  KeyboardArrowRight: <KeyboardArrowRight />,
  // Chart
  BarChart: <BarChart />,
  SsidChart: <SsidChart />,
  // Misc
  Home: <Home />,
  StarBorder: <StarBorder />,
};

const Icons = ({ iconName }: { iconName: string }) => {
  return iconList[iconName];
};

export default Icons;
